/* istanbul ignore file */
import React from 'react';
import { Box } from '@mui/material';

const PassportNumberLayout = ({
  passportNumberInput,
  passportSeriesInput,
}: {
  passportNumberInput: React.ReactElement;
  passportSeriesInput: React.ReactElement;
}) => {
  return (
    <>
      <Box sx={{ display: 'inline-block', width: 'calc(40% - 15px)', marginRight: '5px' }}>{passportSeriesInput}</Box>
      <Box sx={{ display: 'inline-block', width: '60%' }}>{passportNumberInput}</Box>
    </>
  );
};

export default PassportNumberLayout;
